import { stylesheet } from "typestyle";

export default stylesheet({
  root: {
    margin: "2rem",
  },
});
